import { useEffect } from "react";

export default function GlobalTTS() {
  useEffect(() => {
    const speak = (text) => {
      if (!text) return;
      speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 1;
      utterance.pitch = 1;
      utterance.lang = "en-US";
      speechSynthesis.speak(utterance);
    };

    const handleEvent = (e) => {
      const isEnabled = localStorage.getItem("TTS") === "true";
      if (!isEnabled) return;

      // Find closest parent with data-tts="true"
      const target = e.target.closest('[data-tts="true"]');

      if (!target) return;

      const text =
        target.getAttribute("data-tts-text") || target.innerText?.trim();

      if (text) speak(text);
    };

    document.addEventListener("mouseover", handleEvent);
    document.addEventListener("focusin", handleEvent);

    return () => {
      document.removeEventListener("mouseover", handleEvent);
      document.removeEventListener("focusin", handleEvent);
    };
  }, []);

  return null;
}
